import { handleOpenToaster, toasterData, ErrorMessages } from "@amzn/rangoli-seller-desktop-utils/src/index";
import { useQuery } from "react-query";

import { smartbiz } from "./ApiClient";
import { apiEndpoints } from "../constants/apiConstants";

const { marketplaceConnectortasks, status } = apiEndpoints;

export const getTaskStatusAPI = async (taskId: string) => {
  const endpoint = `${marketplaceConnectortasks}${taskId}${status}`; 
    const response = (await smartbiz.get(endpoint)).data;
    return response;
};

const useGetTaskStatus = (taskId: string) => {
  return useQuery(
    ["TaskStatus", taskId],
    () => getTaskStatusAPI(taskId),
    {
      enabled: !!taskId,
      refetchOnWindowFocus: false,
      refetchInterval: false
    }
  );
};

export default useGetTaskStatus;